function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMumbaiIndiansLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 188.98891,
    viewBox: "0 0 300 188.98891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-92.179865,-344.07435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2988",
    transform: "matrix(0.60914819,0,0,0.60914819,-119.52167,186.42247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2990"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 685.963,425.729 c 43.785,-29.317 68.708,-66.604 61.268,-99.928 -12.593,-56.304 -111.275,-82.208 -220.421,-57.815 -109.16,24.38 -187.418,89.823 -174.831,146.146 8.54,38.229 56.737,62.42 120.986,66.385 l -8.507,-0.131 h -14.282 l -8.907,33.104 -31.904,-31.574 1.73,-7.277 -37.486,0.018 -26.072,93.643 h 60.903 l 7.813,-32.642 32.926,33.365 h 44.197 c 0,0 30.562,1.398 47.922,-13.423 l -3.594,12.184 h 57.193 l 9.891,-13.417 h 22.493 l 3.274,12.949 h 53.839 l 8.759,-33.4 33.928,33.625 55.006,0.083 9.085,-0.385 c 16.623,-1.292 30.321,-14.614 30.321,-31.35 0,0 1.636,-18.603 -14.355,-27.041 l 11.241,0.035 c 0,0 11.408,-0.296 16.386,-7.235 2.492,-3.484 4.907,-8.475 4.973,-13.879 l 0.29,-5.944 -0.201,-6.294 h -17.992 l 13.293,-50.082 H 690.114 l -4.151,0.28 z",
    id: "path2992"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 631.58789,
    y1: 303.72949,
    x2: 367.15991,
    y2: 541.82147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004081"
    },
    id: "stop2995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1156,
    style: {
      stopColor: "#00488A"
    },
    id: "stop2997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4913,
    style: {
      stopColor: "#0061A5"
    },
    id: "stop2999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7996,
    style: {
      stopColor: "#0070B8"
    },
    id: "stop3001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0077C0"
    },
    id: "stop3003"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)",
      fillRule: "evenodd"
    },
    clipRule: "evenodd",
    d: "m 417.321,464.746 c 20.593,-2.418 47.329,-10.91 74.252,-28.339 0,0 -17.613,2.714 -38.073,2.003 -20.428,-0.693 -43.638,-4.794 -54.509,-18.3 10.513,6.169 29.734,8.403 58.284,-0.03 -2.501,-0.551 -13.98,-2.987 -23.074,-10.572 -9.028,-7.515 -15.651,-20.072 -8.768,-40.594 -0.391,10.128 5.799,19.633 24.659,22.045 -0.984,-3.348 -3.947,-10.229 -1.642,-21.209 2.308,-10.898 9.873,-25.713 29.652,-44.962 -8.641,10.81 -13.722,23.231 -7.269,32.813 3.064,-6.293 7.515,-14.845 18.084,-25.583 10.43,-10.602 26.914,-23.331 53.931,-38.058 -14.448,9.417 -28.203,21.725 -33.512,34.923 8.889,-7.917 18.976,-16.113 34.389,-24.303 15.29,-8.113 35.818,-16.292 65.698,-24.292 -18.123,6.371 -38.147,16.273 -53.78,29.986 11.657,-5.766 25.518,-11.941 43.409,-16.25 17.835,-4.308 39.717,-6.833 67.534,-5.434 -19.076,1.061 -42.47,5.891 -66.349,16.955 9.043,-1.57 24.403,-3.858 41.791,-2.4 17.414,1.47 37.092,6.732 54.888,20.386 -14.836,-6.845 -36.404,-10.448 -64.204,-6.086 2.771,0.841 15.509,4.379 26.674,14.003 11.26,9.731 21.074,25.743 17.539,51.896 -2.368,-15.835 -13.047,-30.312 -36.396,-37.086 2.204,3.295 5.259,13.079 4.178,26.004 -1.067,13.079 -6.537,29.506 -21.521,45.839 -10.382,11.663 -19.2,14.762 -19.2,14.762 0,0 6.021,-6.721 10.735,-17.292 4.714,-10.478 8.154,-24.665 3.321,-39.694 -4.59,26.33 -27.477,47.973 -49.703,62.729 -22.535,14.987 -44.183,22.774 -45.282,21.347 0,0 9.307,-6.501 20.039,-16.351 10.626,-9.784 21.542,-19.586 27.27,-32.76 -31.895,32.345 -81.304,52.334 -126.74,54.74 -13.997,0.746 -23.713,-0.699 -26.305,-0.836 z",
    id: "path3005"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 567.401,356.493 c -4.13,-6.661 -17.613,-6.347 -30.217,0.747 -12.729,7.111 -19.788,18.425 -15.793,25.204 4.057,6.868 17.779,6.507 30.57,-0.771 12.708,-7.194 19.517,-18.502 15.44,-25.18 z",
    id: "path3007"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 525.24512,
    cy: 405.47269,
    r: 141.7287,
    gradientTransform: "matrix(0.9186,0,0,0.9186,64.5488,2.9385)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC32"
    },
    id: "stop3010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#FFCC32"
    },
    id: "stop3012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#ED1B2F"
    },
    id: "stop3014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED1B2F"
    },
    id: "stop3016"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "m 661.064,345.583 c -8.208,-14.169 -22.789,-21.334 -39.658,-23.515 -16.872,-2.175 -36.129,0.557 -53.715,6.3 12.122,-4.776 23.26,-8.095 30.496,-9.197 20.368,-7.58 38.701,-9.482 52.707,-8.362 -19.615,-4.344 -40.298,-3.129 -59.593,1.523 -19.367,4.676 -37.436,12.794 -51.665,22.229 9.209,-6.999 18.442,-12.759 25.251,-15.871 14.91,-10.945 32.185,-17.968 47.238,-21.903 -23.989,4.16 -44.906,11.912 -61.79,21.215 -17.029,9.393 -30.01,20.416 -37.744,31 4.24,-7.485 9.639,-14.188 14.632,-18.46 6.942,-11.354 19.838,-21.18 32.671,-28.351 -23.053,10.602 -39.954,22.507 -50.867,33.98 -11.008,11.604 -15.983,22.828 -15.13,31.906 -2.098,-5.985 -2.047,-11.917 -0.098,-16.326 -2.593,-9.032 3.541,-19.479 12.009,-28.25 -17.867,14.916 -27.103,28.38 -29.284,39.302 -2.199,11.064 2.717,19.438 12.981,24.072 -8.703,-2.323 -14.632,-5.671 -16.593,-8.996 -12.569,-3.888 -15.207,-12.499 -13.062,-21.085 -16.735,33.187 7.298,47.137 42.947,42.508 -13.307,2.862 -24.339,3.84 -30.33,2.945 -14.896,5.31 -33.278,0.291 -39.457,-5.653 6.062,13.63 20.742,19.408 38.908,19.284 18.169,-0.136 39.69,-6.175 59.419,-15.971 -13.358,7.775 -26.087,13.654 -34.562,16.102 -5.565,8.966 -43.762,15.349 -58.693,15.26 15.319,3.224 35.835,2.519 53.383,-1.506 27.483,-6.329 53.475,-23.201 73.645,-42.39 0,0 0.054,-0.06 0.122,-0.148 -0.015,0.054 -0.068,0.089 -0.122,0.148 -6.127,9.055 -35.628,31.954 -35.628,31.954 -2.323,9.025 -29.198,21.44 -57.365,34.697 31.749,-7.905 65.955,-22.176 90.522,-44.357 11.971,-10.809 18.863,-20.155 22.786,-27.308 5.422,-9.849 5.322,-15.716 5.322,-15.716 0,0 0,-0.029 0.027,-0.036 1.559,11.616 -4.611,23.041 -4.611,23.041 -2.575,28.92 -28.828,46.823 -28.828,46.823 5.953,-3.443 13.328,-8.492 13.328,-8.492 22.828,-18.686 34.636,-35.872 38.354,-50.035 3.662,-14.009 -0.468,-25.168 -9.698,-32.013 8.188,4.083 13.885,9.091 15.601,13.536 14.17,8.16 17.23,21.381 14.223,34.615 10.271,-21.571 8.658,-36.991 0.427,-47.019 -8.166,-9.944 -22.993,-14.726 -39.569,-14.946 12.036,-0.835 22.226,-0.344 27.817,1.31 21.005,-0.935 35.044,4.57 43.246,12.156 l 0,0 z m -95.737,41.506 0,0 0,0 0,0 z m -15.859,-8.379 0,0 c -12.783,7.07 -26.514,7.419 -30.543,0.752 -4,-6.62 3.082,-17.625 15.841,-24.558 12.62,-6.886 26.063,-7.206 30.173,-0.729 4.127,6.525 -2.75,17.53 -15.471,24.535 z",
    id: "path3018"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f79433"
    },
    d: "m 665.153,326.198 c 47.355,12.611 51.188,64.82 -12.431,92.531 52.781,-30.846 39.706,-76.199 12.306,-92.282 l 0.125,-0.249 z",
    id: "path3020"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a65d"
    },
    d: "m 658.794,426.196 c 74.729,-26.354 97.797,-132.598 1.1,-128.989 55.751,-17.968 83.076,15.195 74.383,54.296 -4.507,20.315 -17.444,38.123 -33.16,51.32 -12.668,10.632 -27.471,18.62 -42.323,23.373 z",
    id: "path3022"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00a65d"
    },
    d: "m 435.161,417.923 c -54.414,-8.824 -47.667,-69.383 22.339,-91.15 -61.614,29.388 -55.801,83.026 -22.199,90.901 l -0.14,0.249 z",
    id: "path3024"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f79433"
    },
    d: "m 450.4,316.71 c -77.14,18.069 -114.656,123.01 -18.163,129.92 -83.079,17.085 -94.579,-65.141 -28.054,-109.628 9.899,-6.625 21.026,-12.22 32.279,-16.232 4.498,-1.6 9.115,-2.922 13.938,-4.06 z",
    id: "path3026"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "636.245,428.419 608.199,447.441 608.078,447.211 590.649,429.106 578.835,472.628 591.325,472.628 597.121,451.306 605.308,460.136 617.631,451.785 611.978,472.628 624.435,472.628 ",
    id: "polygon3028"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 653.79492,
    y1: 471.4043,
    x2: 653.59772,
    y2: 433.7261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3039"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "m 646.568,471.442 c -5.882,0 -10.765,-1.618 -13.748,-4.622 -2.856,-2.845 -3.813,-6.685 -2.679,-10.875 l 5.997,-22.128 h 8.406 l -5.479,20.244 c -0.996,3.703 -0.358,6.934 1.808,9.078 1.729,1.737 4.329,2.649 7.49,2.649 7.206,0 13.488,-4.664 15.292,-11.337 l 5.621,-20.635 h 8.377 l -5.876,21.726 c -2.466,9.079 -13.297,15.9 -25.209,15.9 l 0,0 z",
    id: "path3041"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 780.33008,
    y1: 470.6709,
    x2: 780.13672,
    y2: 433.73489
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3046"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3052"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "m 793.677,470.554 -1.686,-7.1 h -19.909 l -5.532,7.1 h -8.658 l 24.001,-29.388 6.11,-7.473 h 10.563 l -2.626,3.188 -0.05,0.089 c -0.693,1.043 -1.005,2.193 -0.848,3.36 l 0.006,0.143 7.716,30.081 h -9.087 z m -17.474,-12.409 h 14.645 l -3.372,-14.472 -11.273,14.472 z",
    id: "path3054"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "826.982,431.666 814.496,431.666 814.496,431.666 803.452,472.468 815.921,472.468 ",
    id: "polygon3056"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 764.209,443.791 c 1.132,-4.22 -0.403,-6.88 -1.908,-8.367 -2.281,-2.312 -6.098,-3.586 -10.724,-3.586 h -26.588 l -11.079,40.79 h 29.119 c 9.398,0 17.318,-4.966 19.266,-12.113 1.097,-4.106 -0.305,-7.503 -3.837,-9.57 2.883,-1.719 4.957,-4.244 5.751,-7.154 z m -14.137,15.74 c -0.53,1.997 -3.209,3.52 -6.202,3.52 h -14.865 l 1.751,-6.482 h 15.669 c 1.44,0 2.575,0.35 3.194,0.978 0.64,0.633 0.602,1.421 0.453,1.984 z m 1.616,-15.657 c -0.403,1.559 -2.172,3.105 -5.188,3.105 h -13.145 l 1.49,-5.512 h 13.968 c 0.827,0 1.956,0.125 2.543,0.712 0.562,0.551 0.456,1.298 0.332,1.695 z",
    id: "path3058"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.64062,
    y1: 470.68951,
    x2: 739.44708,
    y2: 433.7388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3069"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "m 716.485,470.672 10.007,-36.866 h 25.085 c 4.099,0 7.42,1.061 9.354,3.005 1.639,1.629 2.102,3.804 1.372,6.482 -0.646,2.371 -2.37,4.498 -4.839,5.956 l -2.897,1.725 2.897,1.671 c 2.788,1.618 3.787,4.166 2.919,7.366 -1.71,6.294 -8.839,10.661 -17.354,10.661 h -26.544 z m 9.948,-5.659 h 17.438 c 3.917,0 7.331,-2.086 8.102,-4.972 0.403,-1.494 0.062,-2.875 -0.951,-3.899 -0.999,-0.99 -2.599,-1.547 -4.596,-1.547 H 729.26 l -2.827,10.418 z m 4.346,-16.06 h 15.72 c 4.056,0 6.471,-2.276 7.091,-4.552 0.376,-1.356 0.076,-2.702 -0.854,-3.603 -0.845,-0.854 -2.166,-1.28 -3.924,-1.28 h -15.464 l -2.569,9.435 z",
    id: "path3071"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ffffff"
    },
    points: "701.979,472.628 714.441,472.628 725.518,431.838 721.605,431.838 698.221,447.441 683.27,431.838 679.918,431.838 668.852,472.628 681.326,472.628 687.121,451.306 695.329,460.136 707.655,451.785 ",
    id: "polygon3073"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 815.8623,
    y1: 472.90619,
    x2: 815.8623,
    y2: 436.1279,
    gradientTransform: "matrix(1,-0.0052,0.0052,1,-2.9442,1.7959)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3084"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "m 815.121,469.256 c 0,-0.041 0.029,-0.249 0.062,-0.48 l 9.366,-35.13 -8.195,0.029 -10.338,36.831 h 0.331 l 8.33,-0.047 0.047,-0.018 h 0.006 1.168 c -0.748,-0.355 -0.777,-0.687 -0.777,-1.185 z",
    id: "path3086"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 697.27539,
    y1: 470.793,
    x2: 697.0813,
    y2: 433.72421
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3097"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "m 713.339,469.582 c 0,-0.012 0.015,-0.22 0.035,-0.433 l 1.292,-4.812 8.271,-30.531 h -0.735 l -24.271,16.173 -15.491,-16.173 h -1.001 l -10.019,36.866 h 8.403 l 6.326,-23.283 9.458,10.175 15.316,-10.406 -6.367,23.598 8.421,-0.059 1.063,-0.013 c -0.686,-0.331 -0.701,-0.628 -0.701,-1.102 z",
    id: "path3099"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.52728,
    y1: 470.75781,
    x2: 607.32867,
    y2: 432.8111
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3106"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3110"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "m 623.255,469.582 c 0,-0.018 0,-0.06 0.015,-0.113 l 10.176,-36.795 -25.521,17.305 -16.297,-16.997 -10.217,37.69 h 8.418 l 6.314,-23.283 9.459,10.175 15.304,-10.406 -6.37,23.515 h 0.394 l 0,0 h 0.106 4.848 2.957 0.057 l 0,0 h 1.063 c -0.689,-0.339 -0.706,-0.641 -0.706,-1.091 z",
    id: "path3112"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#50c8f4",
      strokeWidth: 0.0131
    },
    d: "M 352.713,564.821",
    id: "path3114"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#50c8f4",
      strokeWidth: 0.0131
    },
    d: "M 787.938,503.711",
    id: "path3116"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1c24"
    },
    d: "m 546.73,545.905 -4.854,18.578 h 50.805 l 9.938,-13.209 h 27.468 l 3.183,12.741 h 48.905 l 9.354,-35.913 36.894,36.304 h 50.42 l 9.094,-0.373 c 16.623,-1.31 30.318,-13.274 30.318,-30.016 0,-4.664 -1.055,-9.092 -2.951,-13.044 0,0 -5.2,-13.233 -25.465,-12.303 0,0 -8.409,-0.054 -10.454,0.018 -2.026,0.095 -3.473,-0.101 -3.473,-0.101 0.575,0.029 -0.456,-0.035 -0.602,-0.604 -0.101,-0.438 0.223,-0.907 0.613,-1.079 0,0 1.847,-1.362 10.265,-1.362 8.409,0 28.736,0 28.736,0 0,0 12.109,0.717 17.126,-6.193 2.948,-4.065 4.444,-9.191 4.516,-14.584 v -5.541 l -46.312,0.065 c 0,0 -20.546,-0.658 -32.221,8.463 l 1.321,-5.044 h -30.01 l -9.506,35.824 -35.596,-35.355 h -4.367 l 39.809,39.504 c 0,0 0.883,0.788 1.882,0.539 0.862,-0.226 1.244,-0.776 1.443,-1.589 0.195,-0.823 9.333,-35.663 9.333,-35.663 h 23.015 l -3.908,14.602 c 0,0 6.447,-18.655 39.023,-18.092 9.114,0.159 42.758,0 42.758,0 l 0.041,2.252 c -0.053,4.877 -1.605,9.393 -4.189,13.126 0,0 -4.19,5.049 -14.501,4.255 h -28.354 c -10.323,0 -13.022,3.088 -13.022,3.088 -0.862,0.663 -1.422,1.706 -1.422,2.88 0,1.997 1.896,3.123 3.837,3.248 0,0 8.646,0.8 14.317,0.408 5.71,-0.408 16.884,0.996 21.826,9.767 2.054,3.681 3.084,7.994 3.084,12.517 0,14.88 -12.187,26.039 -28.546,27.117 l -55.683,0.096 -37.768,-36.772 c 0,0 -0.989,-1.612 -2.299,-1.304 -1.298,0.29 -1.401,2.109 -1.401,2.109 l -9.014,35.558 H 635.84 l -3.304,-12.824 h -31.447 l -10.033,13.233 h -45.074 l 8.604,-32.57 c 0,0 -10.649,30.964 -55.19,32.86 l -46.775,0.201 -37.581,-36.458 c 0,0 -0.498,-1.221 -1.698,-0.906 -1.209,0.296 -1.505,2.602 -1.505,2.602 l -8.806,34.271 h -45.969 l 22.294,-79.34 26.028,-0.006 0.954,-3.503 h -29.382 l -24.244,86.439 h 52.58 l 9.313,-35.657 36.464,35.895 h 40.882 c 10e-4,-10e-4 35.668,2.345 54.779,-19.155",
    id: "path3118"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1c24"
    },
    d: "m 402.926,484.942 39.412,38.751 c 0,0 0.673,0.925 1.775,0.646 1.197,-0.178 1.39,-1.754 1.39,-1.754 l 9.539,-35.403 h 57.827 c 0,0 12.952,-0.871 24.552,3.283 11.598,4.148 21.992,15.758 19.524,29.755 l 8.865,-33.513 h 22.955 l -18.478,69.017 56.067,-69.431 h 28.39 l -8.158,10.104 c 0,0 -3.354,2.951 -1.528,7.586 l 13.224,50.722 19.322,-71.617 h -3.525 l -15.734,59.196 -10.109,-38.591 c 0,0 -1.352,-3.064 1.629,-6.234 l 11.423,-14.058 h -36.65 l -47.397,58.628 15.544,-58.557 H 563.29 l -5.579,21.104 c 0,0 -4.519,-11.533 -19.382,-16.807 -13.577,-4.818 -25.714,-3.538 -25.714,-3.538 h -60.251 l -9.488,35.51 -35.364,-34.799 h -4.586 z",
    id: "path3120"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 500.743,540.838 c 14.46,-0.083 26.958,-7.609 29.705,-17.915 0.756,-2.832 0.963,-6.927 -2.367,-10.163 -3.117,-3.088 -8.433,-4.682 -15.379,-4.646 l -15.124,-0.029 -8.679,32.754 h 11.844 z",
    id: "path3122"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 549.32,498.11 c -5.129,-5.067 -15.079,-11.04 -33.459,-10.945 l -38.864,0.195 -19.592,74.267 40.173,-0.13 c 28.546,0.064 52.891,-16.001 58.432,-36.855 2.709,-10.193 0.336,-19.604 -6.69,-26.532 z m -15.722,25.489 c -3.129,11.752 -16.925,20.315 -32.846,20.41 l -16.134,0.006 10.451,-39.368 h 17.618 c 7.811,-0.053 13.938,1.885 17.681,5.589 3.461,3.418 4.617,8.171 3.23,13.363 z",
    id: "path3124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.7778,
    y1: 557.8584,
    x2: 379.7778,
    y2: 484.5654,
    gradientTransform: "matrix(1,-0.0052,0.0052,1,-2.9081,2.3818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3135"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "m 380.673,558.261 c -1.532,-0.516 -1.564,-1.445 -1.564,-2.424 0,-0.047 0.047,-0.456 0.118,-0.912 l 18.555,-69.965 h -15.974 l -20.431,73.301 h 19.296 z",
    id: "path3137"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1b2f"
    },
    d: "m 533.598,523.599 c -3.129,11.752 -16.925,20.315 -32.846,20.41 l -16.134,0.006 10.451,-39.368 h 17.618 c 7.811,-0.053 13.938,1.885 17.681,5.589 3.461,3.418 4.617,8.171 3.23,13.363 z",
    id: "path3139"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m 500.743,540.838 c 14.46,-0.083 26.958,-7.609 29.705,-17.915 0.756,-2.832 0.963,-6.927 -2.367,-10.163 -3.117,-3.088 -8.433,-4.682 -15.379,-4.646 l -15.124,-0.029 -8.679,32.754 h 11.844 z",
    id: "path3141"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ed1c24"
    },
    points: "628.274,531.148 614.09,531.148 624.947,517.732 ",
    id: "polygon3143"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1b2f"
    },
    d: "m 793.707,533.229 c -1.965,-1.789 -3.565,-1.683 -8.561,-1.647 l -6.679,0.03 c -5.844,-0.214 -10.821,-1.061 -15.803,-2.999 -3.146,-1.215 -6.29,-3.218 -6.385,-3.277 -6.786,-4.919 -7.438,-10.939 -7.2,-14.211 0,-0.373 0.018,-0.983 0.079,-1.754 l -9.229,34.431 c 2.634,-1.878 5.816,-2.963 9.221,-2.98 l 32.36,0.788 c 3.097,-0.267 11.464,0.042 12.712,-4.48 0.299,-1.092 0.142,-3.32 -0.515,-3.901 z m -12.176,5.114 -32.387,-0.782 c -1.7,0.006 -3.354,0.249 -4.916,0.67 l 4.374,-16.498 c 1.324,1.985 3.253,3.982 6.009,5.831 8.054,5.41 17.545,6.673 23.731,6.892 l 6.881,0.131 c 3.884,-0.029 5.843,-0.314 6.08,0.794 0.56,2.393 -2.5,2.879 -9.772,2.962 z",
    id: "path3145"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 614.14447,
    y1: 558.13867,
    x2: 614.14447,
    y2: 490.42291,
    gradientTransform: "matrix(1,-0.0052,0.0052,1,-2.9081,2.3818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3156"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "m 638.275,557.194 -3.108,-12.901 -35.824,0.172 -9.977,12.979 -16.569,0.089 43.771,-54.236 11.145,-13.755 20.016,-0.106 -5.142,6.353 -0.076,0.131 c -1.225,1.831 -1.719,3.869 -1.473,5.908 l 0.038,0.213 14.406,55.072 -17.207,0.081 z m -30.988,-23.058 25.598,-0.143 -6.023,-25.245 -19.575,25.388 z",
    id: "path3158"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 507.70511,
    y1: 558.14648,
    x2: 507.70511,
    y2: 490.41891,
    gradientTransform: "matrix(1,-0.0052,0.0052,1,-2.9081,2.3818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3169"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "m 461.417,558.119 18.019,-67.813 36.387,-0.189 c 17.263,-0.089 26.458,5.398 31.133,10.015 6.164,6.08 8.241,14.383 5.834,23.367 -5.177,19.503 -28.94,34.301 -55.3,34.443 l -36.073,0.177 z m 18.887,-11.047 20.404,-0.106 c 17.34,-0.089 32.469,-9.689 35.978,-22.821 1.704,-6.412 0.228,-12.273 -4.095,-16.534 -4.362,-4.309 -11.287,-6.572 -19.983,-6.52 l -20.113,0.107 -12.191,45.874 z",
    id: "path3171"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.42139,
    y1: 558.14362,
    x2: 567.42139,
    y2: 490.41309,
    gradientTransform: "matrix(1,-0.0052,0.0052,1,-2.9081,2.3818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3174"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3178"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3182"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "m 567.377,555.203 c 0,-0.106 0.264,-2.033 0.285,-2.217 0.145,-1.126 0.679,-3.307 0.877,-4.16 l 15.704,-59.071 -15.995,0.089 -16.288,61.342 -1.725,6.471 0,0 15.986,-0.077 h 0.275 l 0.006,-0.018 2.379,-0.012 c -1.45,-0.717 -1.504,-1.369 -1.504,-2.347 z",
    id: "path3184"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.08588,
    y1: 558.9043,
    x2: 706.08588,
    y2: 488.6572,
    gradientTransform: "matrix(1,-0.0052,0.0052,1,-2.9081,2.3818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3195"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "m 734.303,489.025 -7.47,28.096 0,0 -0.015,0.131 -1.564,5.861 -0.09,0.153 -1.285,4.789 c -0.644,1.546 -1.832,1.268 -2.48,0.966 l -4.065,-3.988 c -0.035,-0.048 -0.106,-0.089 -0.154,-0.119 l -0.13,-0.095 -7.225,-7.206 -0.379,-0.385 0,0 -29.915,-29.726 -18.522,69.638 16.268,-0.095 0,0 2.367,-0.012 c -1.446,-0.717 -1.487,-1.363 -1.496,-2.329 0,-0.124 0.264,-2.044 0.284,-2.24 0.204,-1.416 0.975,-4.516 0.975,-4.516 l 5.067,-19.028 h -0.021 l 0.928,-3.455 0.794,-2.97 0.03,-0.041 1.221,-4.48 c 0.616,-1.541 1.831,-1.256 2.477,-0.966 l 3.736,3.704 0.086,0.053 3.331,3.313 4.803,4.717 h -0.05 l 28.849,28.683 h 1.422 l 17.316,-64.915 c 0.309,-1.298 0.788,-2.501 1.41,-3.615 l -16.503,0.077 z",
    id: "path3197"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.0131
    },
    d: "M 761.779,465.807",
    id: "path3199"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 783.20612,
    y1: 559.32709,
    x2: 783.20343,
    y2: 487.38959,
    gradientTransform: "matrix(1,-0.0052,0.0052,1,-2.9081,2.3818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004081"
    },
    id: "stop3202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0077C0"
    },
    id: "stop3204"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "m 807.891,521.999 c 2.122,3.146 3.592,7.158 3.592,11.573 0,13.038 -11.701,22.697 -22.576,23.408 l -8.113,0.534 c -2.841,0.142 -4.915,0.142 -5.33,0.142 0,0 -3.722,0.125 -8.03,-0.124 -28.585,-1.505 -31.201,0.231 -31.201,0.231 -0.139,-0.931 0.071,-2.182 0.24,-3.011 0.106,-0.616 0.296,-1.363 0.584,-2.181 1.881,-5.15 6.441,-8.67 12.089,-8.706 l 32.321,0.782 c 3.31,-0.023 13.366,-0.124 15.93,-7.277 1.008,-2.785 0.06,-4.765 -0.59,-5.671 -1.777,-2.519 -5.366,-3.503 -11.659,-3.485 l -6.572,-0.064 c -4.896,-0.16 -11.729,-1.452 -15.927,-3.153 -2.877,-1.179 -4.472,-2.513 -4.472,-2.513 -5.259,-3.899 -6.106,-8.599 -5.854,-11.455 0.08,-2.661 0.939,-23.995 34.141,-25.133 0,0 3.523,-0.213 5.203,-0.213 l 10.61,0.101 c 3.378,0.166 8.75,0.166 12.276,0.313 2.412,0.019 4.32,0 6.744,0.019 2.478,-0.077 5.44,-0.077 8.549,-0.664 0,0 -0.068,3.502 -0.765,5.511 -1.879,5.204 -5.414,7.681 -11.097,7.734 l -33.395,0.118 c -3.327,0.054 -13.956,0.361 -16.019,7.188 l -0.05,0.148 c -0.632,1.932 -0.376,3.834 0.723,5.327 1.784,2.466 5.405,3.521 11.749,3.503 l 11.049,-0.071 c 0,10e-4 10.724,-0.556 15.85,7.089 z",
    id: "path3206"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3208"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1c24"
    },
    d: "m 637.875,427.287 0.759,-2.804 -30.146,20.404 -18.833,-19.646 -13.37,49.359 h 16.543 l 5.254,-19.367 6.945,7.479 9.321,-6.347 -4.939,18.235 h 16.528 l 2.048,-7.503 c 0,0 3.295,5.612 11.251,7.42 10.907,2.743 20.418,-1.659 22.051,-2.418 1.929,-0.877 5.02,-2.655 6.824,-4.332 l -1.831,6.833 h 16.555 l 5.247,-19.367 6.946,7.479 9.324,-6.347 -4.945,18.235 h 42.66 c 0,0 6.444,0.355 11.873,-2.294 l 4.023,-4.96 c 0,0 -2.163,2.051 -5.18,3.312 -3.022,1.274 -6.175,2.134 -10.856,1.991 h -39.948 l 5.677,-20.866 -12.326,8.351 -8.208,-8.83 -5.795,21.322 h -12.475 l 3.632,-13.382 c 0,0 -2.041,4.67 -7.312,8.368 -3.985,2.797 -8.667,4.771 -14.22,5.529 -2.231,0.308 -9.188,0.889 -14.884,-1.767 -1.713,-0.8 -7.831,-3.898 -8.344,-11.117 l -3.289,12.368 h -12.457 l 5.653,-20.843 -12.323,8.351 -8.187,-8.83 -5.796,21.322 h -12.489 l 11.814,-43.521 17.615,18.246 29.61,-20.063 z",
    id: "path3210"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1c24"
    },
    d: "m 637.199,429.858 -0.521,1.974 h 10.43 l -5.777,21.399 c 0,0 -1.624,4.344 -0.054,7.212 1.559,2.845 5.873,4.486 11.707,2.649 1.248,-0.409 6.7,-2.53 8.629,-8.635 0.213,-0.705 3.138,-11.573 3.138,-11.573 l 3.017,-11.035 h 15.503 l 14.951,15.592 23.385,-15.604 h 29.782 c 0,0 8.074,-0.385 11.746,4.51 3.891,5.772 -1.094,11.592 -1.094,11.592 0,0 -1.458,1.808 -3.582,3.005 0,0 7.535,3.804 2.477,12.771 l 26.146,-31.983 H 802.7 l -4.915,6.026 c 0,0 -1.212,1.073 -0.658,2.827 0.581,1.831 7.28,28.445 7.28,28.445 l 10.09,-37.364 h 12.486 l -11.062,40.802 h -23.806 l -1.677,-7.052 h -17.399 l -5.529,7.117 h -11.248 l -1.591,1.974 h 13.799 l 5.538,-7.1 h 14.872 l 1.677,7.1 h 26.852 l 12.137,-44.809 h -16.549 l -8.555,31.558 -5.381,-20.997 c 0,0 -0.338,-0.651 0.279,-1.351 0.628,-0.676 7.514,-9.145 7.514,-9.145 h -20.712 l -21.63,26.479 c 0,0 -0.226,-2.727 -2.756,-5.257 0,0 5.375,-4.048 4.734,-11.254 -0.159,-1.742 -1.611,-8.67 -12.69,-9.808 -0.738,-0.065 -2.658,-0.065 -2.658,-0.065 h -30.128 l -22.511,15.029 -14.389,-15.029 h -17.858 l -6.342,23.391 c 0,0 -1.259,5.902 -7.65,7.989 -1.674,0.545 -5.936,1.303 -8.314,-0.623 -2.382,-1.914 -1.002,-5.891 -1.002,-5.891 l 6.712,-24.866 h -12.461 z",
    id: "path3212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3214"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1c24"
    },
    d: "m 749.026,441.468 h -14.182 l -1.49,5.512 h 13.455 c 2.561,-0.077 4.801,-1.576 4.96,-3.562 0.185,-2.003 -2.743,-1.95 -2.743,-1.95 z m -1.988,3.532 -11.117,0.023 0.441,-1.588 h 12.45 c 0,0 0.756,-0.048 0.942,0.089 0.193,0.149 -0.942,1.416 -2.716,1.476 z",
    id: "path3216"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed1c24"
    },
    d: "m 746.863,456.586 -16.107,-0.018 -1.751,6.482 15.458,-0.029 c 2.818,-0.178 5.604,-1.849 5.689,-4.089 0.101,-2.287 -3.289,-2.346 -3.289,-2.346 z m -2.447,4.486 -12.849,0.012 0.702,-2.543 h 14.632 c 0,0 1.334,-0.106 1.277,0.475 -0.053,0.592 -1.427,1.866 -3.762,2.056 z",
    id: "path3218"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ed1c24"
    },
    points: "781.566,455.395 785.967,450.221 787.19,455.395 ",
    id: "polygon3220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.14841,
    y1: 558.43359,
    x2: 428.78391,
    y2: 488.81641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#003B7A"
    },
    id: "stop3223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    style: {
      stopColor: "#004080"
    },
    id: "stop3225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4834,
    style: {
      stopColor: "#004D90"
    },
    id: "stop3227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8594,
    style: {
      stopColor: "#0062AA"
    },
    id: "stop3229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006CB7"
    },
    id: "stop3231"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "m 457.311,490.483 -7.443,28.084 0,0 -0.036,0.131 -1.562,5.878 -0.074,0.131 -1.304,4.807 c -0.634,1.534 -1.84,1.262 -2.477,0.966 l -4.06,-4.001 c -0.047,-0.041 -0.112,-0.076 -0.148,-0.13 l -0.145,-0.089 -7.227,-7.2 -0.379,-0.38 0,0 -29.906,-29.726 -18.439,69.343 h 18.22 c -1.114,-0.641 -1.153,-1.263 -1.165,-2.163 0,-0.106 0.267,-2.033 0.284,-2.223 0.187,-1.416 0.969,-4.51 0.969,-4.51 l 5.079,-19.029 h -0.033 l 0.937,-3.448 0.794,-2.987 0.027,-0.047 1.215,-4.457 c 0.631,-1.553 1.834,-1.269 2.471,-0.983 l 3.754,3.703 0.074,0.054 3.345,3.331 4.792,4.711 h -0.05 l 28.211,28.049 h 2.222 l 17.156,-64.299 c 0.306,-1.292 0.782,-2.507 1.417,-3.604 l -16.519,0.088 z",
    id: "path3233"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMumbaiIndiansLogo);
export default __webpack_public_path__ + "static/media/Mumbai_Indians_Logo.05bf7c3f4aabb6e734d7a6afb2dc37e7.svg";
export { ForwardRef as ReactComponent };